import parseNumber from './parseNumber';

const validateFormRespondentLimits = (respondentLimits, respondentLimitsNumber) => {
  const error = respondentLimits && !parseNumber(respondentLimitsNumber, 'positive-int');
  return error ? 'Enter a positive integer' : false;
};

export default validateFormRespondentLimits;
